import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-label',
    template:
        `
    <p *ngIf="!props?.strong">{{props.label}}</p>
    <p *ngIf="props?.strong"><strong>{{props.label}}</strong></p>`,
})
export class FormlyLabelComponent extends FieldType<FieldTypeConfig> implements OnInit {

    ngOnInit() {
    }

}
